// The Companies board's step-state filters, one active at a time in the URL.
export enum CompaniesBoardFilter {
  RESEARCH_DUE = "research-due",
  RESEARCH_NEVER = "research-never",
  RESEARCH_BLOCKED = "research-blocked",
  RESEARCH_RUNNING = "research-running",
  RESEARCH_QUEUED = "research-queued",
  NEVER_SCORED = "never-scored",
  UNCLEAR = "unclear",
  STRESSED_OR_WORSE = "stressed-or-worse",
  SCORED_NO_FILE = "scored-no-file",
  FILE_DUE = "file-due",
  BEHIND_SCORE = "behind-score",
}
